// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImagePreview__container-f1b7dc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  user-select: none;
}

.ImagePreview__placeholder-d37e68 {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ImagePreview__image-d44eec {
  margin: auto;
  position: relative;
  max-width: 100%;
  height: auto;
}

.ImagePreview__error-image-cd8c4e {
  margin: auto;
  position: relative;
  max-width: 100%;
  height: auto;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/ImagePreview/ImagePreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  overflow: hidden;\n  user-select: none;\n}\n\n.placeholder {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image {\n  margin: auto;\n  position: relative;\n  max-width: 100%;\n  height: auto;\n}\n\n.error-image {\n  margin: auto;\n  position: relative;\n  max-width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImagePreview__container-f1b7dc`,
	"placeholder": `ImagePreview__placeholder-d37e68`,
	"image": `ImagePreview__image-d44eec`,
	"error-image": `ImagePreview__error-image-cd8c4e`,
	"errorImage": `ImagePreview__error-image-cd8c4e`
};
module.exports = ___CSS_LOADER_EXPORT___;
